module.exports = __webpack_public_path__ + "static/media/tinyConnected.8701066c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyConnected.svg
// module id = 502
// module chunks = 0